import { Injectable } from '@angular/core';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { Subject } from 'rxjs';

//declare var SMSReceive: any;

@Injectable({
  providedIn: 'root'
})
export class SmsReceiveService {
  OTP$ = new Subject<string>();
  constructor(private smsRetriever: SmsRetriever) {
  }
  loadOtp(otp: string) {
    this.OTP$.next(otp);
  }

  smsReceiveActive() {
    console.log("function not available ")
    // SMSReceive.startWatch(
    //   () => {
    //     console.log('watch started');
    //     document.addEventListener('onSMSArrive', (e: any) => {
    //       console.log('onSMSArrive()1', e);
    //       const IncomingSMS = e.data;
    //       //console.log('sms.address:' + IncomingSMS.address);
    //       //console.log('sms.body:' + IncomingSMS.body);
    //       /* Debug received SMS content (JSON) */
    //       console.log(JSON.stringify(IncomingSMS));
    //       this.processSMS(IncomingSMS);
    //     });
    //   },
    //   () => { console.log('watch start failed') }
    // )
  }
  processSMS(data) {
    console.log("processSms")
    // Check SMS for a specific string sequence to identify it is you SMS
    // Design your SMS in a way so you can identify the OTP quickly i.e. first 6 letters
    // In this case, I am keeping the first 6 letters as OTP
    const message = data.body;
    if (message) {
      const OTP = data.body.slice(0, 6);
      this.loadOtp(OTP);
      console.log(`OTP received.Proceed to login  ->${OTP}<-`)
      //   this.smsReceiveStop();
    }
  }
  private smsReceiveStop() {
    // SMSReceive.stopWatch(
    //   () => { console.log('watch stopped') },
    //   () => { console.log('watch stop failed') }
    // )
  }
}
